import { format, parse } from 'date-fns'
import _ from 'lodash'
import { DASH } from 'modules/constants'
import { RateDTO } from './Rates/types'
import { LogisticsKRTrip } from './types'

//Утилита для голых цифр, для которых не нужно учитывать часовой пояс
export const removeSeconds = (time?: string | null) => {
  if (time) {
    if (time?.length === 8) {
      const parsedTime = parse(time, 'HH:mm:ss', new Date())
      return format(parsedTime, 'HH:mm')
    }
    return time
  }
  return DASH
}

export const generateRanges = (start: number, end: number, step: number, skipFirst?: boolean) => {
  const resultArray = Array(Math.ceil((end - start) / step))
    .fill(start)
    .map((item, index) => {
      const result = item + index * step
      const nextResult = item + (index + 1) * step

      return {
        lower: index > 0 || skipFirst ? result + 1 : result,
        upper: nextResult,
      }
    })

  return resultArray
}

export const getLogisticsRanges = () => [...generateRanges(0, 500, 50), ...generateRanges(500, 2100, 100, true)]

export const prepareMultipleEditing = (selectedRows: RateDTO[]) => {
  const longestRatesArray = selectedRows
    .map((row) => row.logistics_rates.filter((el) => el?.rate ?? 0 > 0))
    .sort((a, b) => b.length - a.length)[0]

  const preparedLogisticians = _.flatten(selectedRows?.map((row) => row?.responsible_logisticians))
  const selectedRowIds = selectedRows.map((row) => row?.id)
  const responsible_logisticians = _.unionBy(preparedLogisticians, 'id')

  return {
    id: selectedRowIds,
    logistic_rates: longestRatesArray,
    responsible_logisticians,
  }
}

export const getTripVatStatus = (trip: LogisticsKRTrip, t) => {
  if (_.isNil(trip.vat_value)) return `${t('common:vat')} ${t('common:notSpecified')}`
  return trip.vat_value ? `${t('vat.with_vat')} ${trip?.vat_value} %` : t('vat.not_vat')
}
